import React from 'react';
import { AudienceLevel, LEVEL_LABELS } from '../../types/pathway';
import { moduleById } from '../../data/skillModules';
interface PowerPointPreviewProps {
  pathwayName: string;
  company: string;
  audience: AudienceLevel | 'any';
  items: string[];
}

/** A proportional thumbnail of the slide deck generated for PowerPoint. */
export function PowerPointPreview({
  pathwayName,
  company,
  audience,
  items
}: PowerPointPreviewProps) {
  const firstModule = items.length > 0 ? moduleById(items[0]) : null;
  return <div className="space-y-3" aria-label="PowerPoint deck preview" data-id="element-1818" data-mp="1mvoq2aaqwln3">
      <div className="aspect-video overflow-hidden rounded-lg bg-[#30718D] p-5 text-white shadow-sm" data-id="element-1819" data-mp="21sfifzm04x37">
        <p className="text-[9px] font-semibold uppercase tracking-[0.16em] text-white/75" data-id="element-1820" data-mp="1ws9x116bs6tk">
          University of Phoenix · Professional development
        </p>
        <h3 className="mt-6 max-w-[70%] text-xl font-bold leading-tight" data-id="element-1821" data-mp="3d95sxuxgkb2m">
          {pathwayName.trim() || 'Recommended Learning Pathway'}
        </h3>
        <p className="mt-3 text-xs text-white/85" data-id="element-1822" data-mp="1sviydcyka3pc">
          Prepared for {company.trim() || 'your team'}
        </p>
      </div>
      <div className="aspect-video overflow-hidden rounded-lg border border-gray-200 bg-white p-4 shadow-sm" data-id="element-1823" data-mp="1xtu87nouwe7k">
        <p className="text-[8px] font-semibold uppercase tracking-[0.14em] text-[#30718D]" data-id="element-1824" data-mp="22snmhibyw98s">
          The pathway
        </p>
        <div className="mt-3 flex gap-2" data-id="element-1825" data-mp="1a62tyejr9r3n">
          {items.slice(0, 3).map((moduleId, index) => {
          const module = moduleById(moduleId);
          if (!module) return null;
          return <div key={moduleId} className="min-w-0 flex-1 border-l-2 border-[#DB3725] pl-2" data-id="element-1826" data-mp="1j70zj19ue6oc" data-mpi={index}>
                <span className="text-[9px] font-bold text-[#DB3725]" data-id="element-1827" data-mp="1nx94r6shjb5u">0{index + 1}</span>
                <p className="mt-1 text-[10px] font-semibold leading-tight text-gray-900" data-id="element-1828" data-mp="rfl5wn9vbjom">
                  {module.name}
                </p>
              </div>;
        })}
        </div>
        {firstModule && <p className="mt-5 text-[9px] text-gray-500" data-id="element-1829" data-mp="1yrc5hgx1d2ds">
            Built for {audience === 'any' ? 'a mixed audience' : LEVEL_LABELS[audience]}
          </p>}
      </div>
    </div>;
}